import {
  GridColumnMenuFilter,
  GridColumnMenuFilterUIProps,
  GridColumnMenuProps,
  GridColumnMenuSort,
} from "@progress/kendo-react-grid";
import * as React from "react";
import { ComponentType } from "react";

type ColumnMenuWithFilterUiProps = GridColumnMenuProps & {
  filterUI: ComponentType<GridColumnMenuFilterUIProps>;
};

export function ColumnMenuWithFilterUi({
  filterUI,
  ...props
}: ColumnMenuWithFilterUiProps) {
  return (
    <div>
      <GridColumnMenuSort {...props} />
      <GridColumnMenuFilter {...props} expanded filterUI={filterUI} />
    </div>
  );
}
